module.exports = require("vue-ueditor-wrap");